import { render, staticRenderFns } from "./ReadOnlyOrderItem.vue?vue&type=template&id=21e0fbaa&"
import script from "./ReadOnlyOrderItem.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyOrderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports